// Fire-and-forget click logging for the marketplace "Shop on X" CTAs on
// posted scans. Feeds the listing_demand_v1 demand-side signal alongside
// sold_at/sold_price from the outcome feedback loop.
//
// Why direct REST + keepalive: target="_blank" usually keeps the current
// tab alive, but iOS in-app-browser (Capacitor) can swap context fast
// enough to drop the in-flight request. `keepalive: true` tells the
// browser to complete the request even if the page unloads.
//
// Analytics must never break navigation — every failure path is silent.

import { supabase } from "@/integrations/supabase/client";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

export async function logListingClick(
  scanId: string,
  marketplaceName: string,
): Promise<void> {
  if (!scanId || !marketplaceName) return;
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return;

  let token: string | undefined;
  let userId: string | undefined;
  try {
    const { data } = await supabase.auth.getSession();
    token = data.session?.access_token;
    userId = data.session?.user?.id;
  } catch {
    return;
  }
  if (!token || !userId) return; // anonymous clicks don't generate useful signal

  try {
    void fetch(`${SUPABASE_URL}/rest/v1/listing_clicks`, {
      method: "POST",
      keepalive: true,
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Prefer: "return=minimal",
      },
      body: JSON.stringify({
        scan_id: scanId,
        viewer_id: userId,
        marketplace_name: marketplaceName,
      }),
    });
  } catch {
    // Swallow.
  }
}
